import { Box, Flex, HStack, Spacer, Text, useMediaQuery } from "native-base";
import InputField from "../../../../components/input";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import DateInputField from "../../../../components/dateInput";
import FormHeader from "../../../../components/formHeader";
import MultiSelectDropdown from "../../../../components/multiselect";
import CommonBadge from "../../../../components/badge";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import NewTextAreaField from "../../../../components/textArea/newTextArea";
import { COMMONFONTWEIGHT } from "../../../../utils/fonts";
import FileUploader from "../../../../containers/fileUpload";
import ViewUploadImageCards from "../../../../containers/viewUploadImageCards";

const MiceDetails = forwardRef(
  (
    {
      miceFormData,
      setMiceFormData,
      miceErrorFormData,
      setDefaultErrorFrom,
      forceRemount,
      childref,
      showModal,
      edit = false,
    },
    ref
  ) => {
    const [MobileWindow] = useMediaQuery({
      maxWidth: MOBILE_VIEW_WIDTH,
    });
    const options = [
      { id: "1", value: "conference_hall", label: "Conference Hall" },
      { id: "2", value: "gala_dinner", label: "Gala Dinner" },
      { id: "3", value: "event_management", label: "Event Management" },
    ];

    const [miceUpdateFormData, setMiceUpdateFormData] = useState(miceFormData);
    const [selectedFiles, setSelectedFiles] = useState([]);

    useEffect(() => {
      if (showModal) {
        let data = { ...miceUpdateFormData };
        let dataKeys = [
          "additional_info",
          "event_name",
          "event_location",
          "from_date",
          "to_date",
          "estimated_budget",
          "about_event",
          "banner",
        ];
        Object.keys(miceUpdateFormData).map((key) => {
          if (!dataKeys.includes(key)) delete data[key];
        });
        setMiceUpdateFormData(data);
      } else setMiceUpdateFormData(miceFormData);
      if (miceUpdateFormData["banner"].length !== 0 && !edit) {
        const imageUrls = Array.from(miceUpdateFormData["banner"]).map((item) =>
          URL.createObjectURL(item)
        );
        setSelectedFiles(imageUrls);
      }
    }, [showModal]);

    const onInputChange = (e, eName) => {
      setDefaultErrorFrom();
      let detail = { ...miceUpdateFormData };
      if (eName === "service_required") {
        detail["additional_info"][eName] = e;
        setMiceUpdateFormData(detail);
        return;
      }

      let value = e.target.value;
      if (
        ["estimated_budget", "number_of_persons", "number_of_nights"].includes(
          eName
        ) &&
        isNaN(value)
      ) {
        return;
      }

      if (["number_of_persons", "number_of_nights"].includes(eName)) {
        detail["additional_info"][eName] = value;
      } else {
        detail[eName] = value;
      }
      setMiceUpdateFormData(detail);
    };

    const handleSelectedValues = (ind) => {
      let detail = { ...miceUpdateFormData };
      detail["additional_info"]["service_required"] =
        miceUpdateFormData.additional_info.service_required?.filter(
          (item) => item.id !== ind
        );
      setMiceUpdateFormData(detail);
      return;
    };

    const onSubmitDataInput = () => {
      return miceUpdateFormData;
    };

    useImperativeHandle(ref, () => ({
      onSubmitDataInput,
    }));

    const handleFilesSelect = (file) => {
      const imageUrls = Array.from(file).map((item) =>
        URL.createObjectURL(item)
      );
      setSelectedFiles(imageUrls);
      let detail = { ...miceUpdateFormData };
      detail["banner"] = file;
      setMiceUpdateFormData(detail);
    };

    const onDeleteImage = (ind) => {
      setSelectedFiles([]);
      let detail = { ...miceUpdateFormData };
      detail["banner"] = [];
      setMiceUpdateFormData(detail);
    };

    return (
      <>
        {!edit && <FormHeader text="MICE Detail" />}
        <Spacer axis="X" size={4}></Spacer>

        <HStack
          space={MobileWindow ? 1 : 5}
          direction={MobileWindow ? "column" : "row"}
          display={MobileWindow && "block"}
        >
          <Box flex={1}>
            <MultiSelectDropdown
              name="service_required"
              dropItems={options}
              selectedValues={
                miceUpdateFormData.additional_info.service_required
              }
              setSelectedValues={onInputChange}
              label="Service Type"
              text="Service Type"
              isInvalid={miceErrorFormData.service_required}
              errorMessage={miceErrorFormData.service_required}
              important
            />
            {MobileWindow && (
              <Flex direction="row" wrap="wrap" mt={3} space={2}>
                {miceUpdateFormData?.additional_info?.service_required?.map(
                  (item, ind) => (
                    <Box key={ind} mb={1} mr={2}>
                      <CommonBadge
                        text={item?.label}
                        handleSelectedValues={handleSelectedValues}
                        selectedIndex={item?.id}
                      />
                    </Box>
                  )
                )}
              </Flex>
            )}
          </Box>
          <Box flex={1}>
            <InputField
              name="event_name"
              value={
                miceFormData.event_name === ""
                  ? miceUpdateFormData.event_name
                  : miceFormData.event_name
              }
              onChange={onInputChange}
              label="MICE Name"
              placeholder="Enter MICE Name"
              isInvalid={miceErrorFormData.event_name}
              errorMessage={miceErrorFormData.event_name}
              important
              forceRemount={forceRemount}
              ref={childref}
              isDisabled={edit && true}
            />
          </Box>
        </HStack>
        {!MobileWindow && (
          <Flex direction="row" wrap="wrap" mt={3} space={2}>
            {miceUpdateFormData?.additional_info?.service_required.map(
              (item, ind) => {
                return (
                  <Box key={ind} mb={1} mr={2}>
                    <CommonBadge
                      text={item?.label}
                      handleSelectedValues={handleSelectedValues}
                      selectedIndex={item?.id}
                    />
                  </Box>
                );
              }
            )}
          </Flex>
        )}
        <Spacer size={2}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="event_location"
              value={
                miceFormData.event_location === ""
                  ? miceUpdateFormData.event_location
                  : miceFormData.event_location
              }
              onChange={onInputChange}
              label="MICE Location"
              placeholder="Enter MICE Location"
              isInvalid={miceErrorFormData.event_location}
              errorMessage={miceErrorFormData.event_location}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
          <Box flex={1}>
            <DateInputField
              name="from_date"
              onChange={onInputChange}
              defaultValue={miceUpdateFormData.from_date}
              label="MICE From Date"
              placeholder="Select MICE From Date"
              isInvalid={miceErrorFormData.from_date}
              errorMessage={miceErrorFormData.from_date}
              toDate={miceUpdateFormData.to_date}
              important
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <DateInputField
              name="to_date"
              onChange={onInputChange}
              defaultValue={miceUpdateFormData.to_date}
              label="MICE To Date"
              placeholder="Select MICE To Date"
              isInvalid={miceErrorFormData.to_date}
              errorMessage={miceErrorFormData.to_date}
              fromDate={miceUpdateFormData.from_date}
              important
            />
          </Box>
          <Box flex={1}>
            <InputField
              name="number_of_persons"
              value={
                miceFormData.additional_info.number_of_persons === ""
                  ? miceUpdateFormData.additional_info.number_of_persons
                  : miceFormData.additional_info.number_of_persons
              }
              onChange={onInputChange}
              label="Number of Person"
              placeholder="Enter Number of Person"
              isInvalid={miceErrorFormData.number_of_persons}
              errorMessage={miceErrorFormData.number_of_persons}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
        </HStack>
        <Spacer size={5}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={1}>
            <InputField
              name="estimated_budget"
              value={
                miceFormData.estimated_budget === ""
                  ? miceUpdateFormData.estimated_budget
                  : miceFormData.estimated_budget
              }
              onChange={onInputChange}
              label="Estimated budgets"
              placeholder="Enter Estimated budgets"
              isInvalid={miceErrorFormData.estimated_budget}
              errorMessage={miceErrorFormData.estimated_budget}
              forceRemount={forceRemount}
              ref={childref}
            />
          </Box>
          {!MobileWindow &&
            miceFormData.additional_info.hotel_requirement !== "with_hotel" && (
              <Box flex={1}></Box>
            )}
          {miceFormData.additional_info.hotel_requirement === "with_hotel" && (
            <Box flex={1}>
              <InputField
                name="number_of_nights"
                value={
                  miceFormData.additional_info.number_of_nights === ""
                    ? miceUpdateFormData.additional_info.number_of_nights
                    : miceFormData.additional_info.number_of_nights
                }
                onChange={onInputChange}
                label="Number of Nights"
                placeholder="Enter Number of Nights"
                isInvalid={miceErrorFormData.number_of_nights}
                errorMessage={miceErrorFormData.number_of_nights}
                important
                forceRemount={forceRemount}
                ref={childref}
              />
            </Box>
          )}
        </HStack>

        {/* <Spacer axis="X" size={8}></Spacer>
        <FormHeader text="About MICE" /> */}
        <Spacer axis="X" size={4}></Spacer>
        <HStack space={5} direction={MobileWindow ? "column" : "row"}>
          <Box flex={!MobileWindow && 1}>
            <NewTextAreaField
              name="about_event"
              value={
                miceFormData.about_event === ""
                  ? miceUpdateFormData.about_event
                  : miceFormData.about_event
              }
              onChange={onInputChange}
              label="About MICE"
              placeholder="Enter About MICE"
              isInvalid={miceErrorFormData.about_event}
              errorMessage={miceErrorFormData.about_event}
              forceRemount={forceRemount}
              ref={childref}
              basic_details
            />
          </Box>
          <Box flex={!MobileWindow && 1}>
            {!edit && (
              <>
                <Text
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  color={"rgb(115, 115, 115)"}
                >
                  Upload Banner
                </Text>
                <FileUploader
                  files={selectedFiles}
                  show={false}
                  setFiles={handleFilesSelect}
                  accept={["png", "jpg", "jpeg"]}
                  types={".png, .jpg, .jpeg"}
                  forceRemount={forceRemount}
                  // images={true}
                />
                <HStack flex={1} flexWrap={"wrap"}>
                  {selectedFiles.length > 0 && selectedFiles[0] !== "" && (
                    <ViewUploadImageCards
                      ind={0}
                      url={selectedFiles}
                      onDeleteImage={onDeleteImage}
                    />
                  )}
                </HStack>
              </>
            )}
          </Box>
        </HStack>
      </>
    );
  }
);

export default MiceDetails;
